import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import { db } from "@/firebase";
import { addDoc, collection, doc, getDoc, getDocs, serverTimestamp } from "firebase/firestore";
import { Quote, NewQuote } from "@/types/quote";

export const quotesApi = createApi({
  reducerPath: "quotes",
  baseQuery: fakeBaseQuery(),
  tagTypes: ["Quote"],
  endpoints: (builder) => ({
    fetchQuotes: builder.query({
      queryFn: async (organizationId: string) => {
        try {
          const collectionRef = collection(db, `organizations/${organizationId}/quotes`);

          const response = await getDocs(collectionRef).then((querySnapshot) => {
            return querySnapshot.docs.reduce((acc, doc: any) => {
              return [...acc, { ...doc.data(), id: doc.id }];
            }, [] as Quote[]);
          });

          return { data: response };
        } catch (error) {
          return { error };
        }
      },
      providesTags: ["Quote"],
    }),
    fetchQuote: builder.query({
      queryFn: async ({ organizationId, quoteId }: { organizationId: string; quoteId: string }) => {
        try {
          const docRef = doc(db, `organizations/${organizationId}/quotes/${quoteId}`);

          const quote = await getDoc(docRef);

          if (!quote.exists()) {
            throw new Error("La cotización no fué encontrada");
          }

          return { data: quote.data() };
        } catch (error) {
          return { error };
        }
      },
      providesTags: ["Quote"],
    }),
    addQuote: builder.mutation({
      queryFn: async ({ organizationId, payload }: { organizationId: string; payload: NewQuote }) => {
        try {
          const draft: NewQuote = {
            ...payload,
            createdAt: serverTimestamp(),
          };
          
          const collectionRef = collection(db, `organizations/${organizationId}/quotes`);
          const response = await addDoc(collectionRef, draft);
          return { data: response };
        } catch (error) {
          return { error };
        }
      },
      invalidatesTags: ["Quote"],
    }),
  }),
});

export const { useFetchQuotesQuery, useFetchQuoteQuery, useAddQuoteMutation } = quotesApi;
